/**
 * @generated SignedSource<<527330ce78b56ce252c9102529497cf2>>
 * @relayHash 4e843d0de101d7e59ad51c06bd29063b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 29d56afdb1dcc2e8bb8a3de1c966430baf6cd7cd29024fa59ae3d68aae35b9dd

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraFieldSetsMutationInput = {
  replaceFieldSetsInput?: JiraReplaceIssueSearchViewFieldSetsInput | null | undefined;
  resetToDefaultFieldSets?: boolean | null | undefined;
};
export type JiraReplaceIssueSearchViewFieldSetsInput = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  inclusive?: boolean | null | undefined;
  nodes: ReadonlyArray<string>;
};
export type JiraIssueSearchViewFieldSetsContext = {
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type useColumnsChangeMutation$variables = {
  fieldSetsInput?: JiraFieldSetsMutationInput | null | undefined;
  id: string;
  includeView: boolean;
};
export type useColumnsChangeMutation$data = {
  readonly jira: {
    readonly updateFieldSetsView: {
      readonly success: boolean;
      readonly view?: {
        readonly hasDefaultFieldSets: boolean | null | undefined;
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject">;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useColumnsChangeMutation$rawResponse = {
  readonly jira: {
    readonly updateFieldSetsView: {
      readonly success: boolean;
      readonly view: {
        readonly __typename: string;
        readonly hasDefaultFieldSets: boolean | null | undefined;
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useColumnsChangeMutation = {
  rawResponse: useColumnsChangeMutation$rawResponse;
  response: useColumnsChangeMutation$data;
  variables: useColumnsChangeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetsInput"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeView"
},
v3 = [
  {
    "kind": "Variable",
    "name": "fieldSetsInput",
    "variableName": "fieldSetsInput"
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "success"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "hasDefaultFieldSets"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useColumnsChangeMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraFieldSetsViewPayload",
            "kind": "LinkedField",
            "name": "updateFieldSetsView",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "condition": "includeView",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "view",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "FragmentSpread",
                        "name": "ui_issueViewCommonViews_ConfigurableChildIssuesPanelWithFragment_fieldSetViewQueryByProject"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useColumnsChangeMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraFieldSetsViewPayload",
            "kind": "LinkedField",
            "name": "updateFieldSetsView",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "condition": "includeView",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "view",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v5/*: any*/),
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "29d56afdb1dcc2e8bb8a3de1c966430baf6cd7cd29024fa59ae3d68aae35b9dd",
    "metadata": {},
    "name": "useColumnsChangeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "2781df9d7f01978f9c296030093bf665";

export default node;
